<template>
  <i :class="`iconfont ${name}`" :style="style"></i>
</template>

<script>
export default {
  props: ["name", "size", "color", "other"],
  data() {
    return {
      style: {},
    };
  },
  created() {
    this.updateStyle();
  },
  methods: {
    updateStyle() {
      if (this.size) {
        this.style.fontSize = this.size + "px";
      }
      if (this.color) {
        this.style.color = this.color;
      }
      if (this.other) {
        this.style = { ...this.style, ...this.other };
      }
    },
  },
};
</script>
